import {get} from 'lodash'
import createModel from 'utils/model'
import {
    tasks,
    remindUser,
    taskDetail,
    taskSummary,
    detailListByCustomer,
    detailListByUser,
} from 'crm/services/tag-create-group'

export default createModel({
    namespace: 'crm_tagCreateGroup',

    state: {
        tasksTableData: {},
        detailCustomerTableData: {},
        detailUserTableData: {},
    },

    effects: {
        *hasTask(_, {call}) {
            const res = yield call(tasks, {limit: 1, offset: 0})
            return res?.pagination?.rows_found
        },
        *tasks(_, {select, put, call}) {
            const {tasksTableData} = yield select(({crm_tagCreateGroup}) => crm_tagCreateGroup)

            const newParams = {
                offset:
                    tasksTableData.pagination.pageSize * (tasksTableData.pagination.current - 1),
                limit: tasksTableData.pagination.pageSize,
                ...tasksTableData.params,
            }

            const res = yield call(tasks, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    if (draft.tasksTableData) {
                        draft.tasksTableData.dataSource = res.data
                        draft.tasksTableData.pagination.total = get(res, 'pagination.rows_found', 0)
                    }
                },
            })
        },
        *remindUser({payload}, {call}) {
            return yield call(remindUser, payload)
        },
        *taskDetail({payload}, {call}) {
            return yield call(taskDetail, payload)
        },
        *taskSummary({payload}, {call}) {
            return yield call(taskSummary, payload)
        },
        *detailListByCustomer({payload}, {select, put, call}) {
            const {detailCustomerTableData} = yield select(
                ({crm_tagCreateGroup}) => crm_tagCreateGroup,
            )

            const newParams = {
                offset:
                    detailCustomerTableData.pagination.pageSize *
                    (detailCustomerTableData.pagination.current - 1),
                limit: detailCustomerTableData.pagination.pageSize,
                ...detailCustomerTableData.params,
            }

            const res = yield call(detailListByCustomer, {id: payload.id, params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.detailCustomerTableData.dataSource = res.data
                    draft.detailCustomerTableData.pagination.total = get(
                        res,
                        'pagination.rows_found',
                        0,
                    )
                },
            })
        },
        *detailListByUser({payload}, {select, put, call}) {
            const {detailUserTableData} = yield select(({crm_tagCreateGroup}) => crm_tagCreateGroup)

            const newParams = {
                offset:
                    detailUserTableData.pagination.pageSize *
                    (detailUserTableData.pagination.current - 1),
                limit: detailUserTableData.pagination.pageSize,
                ...detailUserTableData.params,
            }

            const res = yield call(detailListByUser, {id: payload.id, params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.detailUserTableData.dataSource = res.data
                    draft.detailUserTableData.pagination.total = get(
                        res,
                        'pagination.rows_found',
                        0,
                    )
                },
            })
        },
    },
    reducers: {},
})
